module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "myVideoPlayer",
    staticClass: "stream-player-wrapper"
  }, [_c('video', {
    ref: "myVideo",
    staticClass: "video-js vjs-default-skin vjs-fluid",
    attrs: {
      "id": "my_video",
      "controls": ""
    }
  }), _vm._v(" "), (_vm.user) ? _c('div', {
    ref: "myOverlay",
    staticClass: "my_overlay"
  }, [_c('v-layout', {
    staticClass: "my-header",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "header"
  }, [_c('v-toolbar-title', {
    on: {
      "click": function($event) {
        _vm.choosePage('album')
      }
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('album')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "3px"
    },
    attrs: {
      "src": "/static/images/ic_music_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Album")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('product')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-2px"
    },
    attrs: {
      "src": "/static/images/ic_tag_active.svg",
      "width": "18"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Product")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('video')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_video_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Video")])], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.stream > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.stream))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('feed')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_home_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Feed")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.activity > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.activity))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('activity')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_alarm_active.svg",
      "width": "18"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Activity")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.message > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.message))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('messages')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_message_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Messages")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.cart > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.cart))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('cart')
      }
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_cart_active.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Cart")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.sell > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.sell))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [(
    _vm.$store.state.auth.user && ['artist', 'brand', 'label'].indexOf(
      _vm.$store.state.auth.user.user_type
    ) > -1
  ) ? _c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('sell')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "src": "/static/images/ic_delivery_active.svg",
      "width": "20"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Sell")])], 1)], 1), _vm._v(" "), (_vm.$store.state.auth.user) ? _c('v-menu', {
    staticClass: "profile-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.player.fullscreen()
      }
    },
    slot: "activator"
  }, [_c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.currentUser.avatar.thumb.url + ')',
    })
  })])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.user.id == _vm.currentUser.id) ? _c('div', {
    staticClass: "stream-sector"
  }, [_c('div', {
    staticClass: "stream-sector__header"
  }, [_c('div', {
    staticClass: "stream-sector__header__left"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__header__right"
  }, [_c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("timeInHours")(_vm.time)))])])]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content"
  }, [_c('div', {
    staticClass: "stream-sector__content__left"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.stream.stats.views_size))]), _c('span', [_vm._v("views")])]), _vm._v(" "), (_vm.stream.assoc_type === 'Album') ? _c('label', [_c('strong', [_vm._v(_vm._s(_vm.stream.stats.downloads_size))]), _c('span', [_vm._v("downloaded")])]) : _vm._e(), _vm._v(" "), _c('label', [_c('strong', [_vm._v(_vm._s(_vm.stream.stats.followed_size))]), _c('span', [_vm._v("followed")])])])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content__right"
  }, [(_vm.showAttachButton) ? [_c('v-btn', {
    staticClass: "display-btn",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openAlbumMerchPopup()
      }
    }
  }, [_vm._v("Display Merch / Album")])] : [_c('div', {
    staticClass: "media d-flex"
  }, [(_vm.stream && _vm.stream.assoc_type == 'Album') ? [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + (_vm.stream.assoc.cover.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n                    " + _vm._s(_vm.stream.assoc.tracks.length) + " tracks\n                  ")])])] : (_vm.stream && _vm.stream.assoc_type == 'ShopProduct') ? [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + (_vm.stream.assoc.covers[0].cover.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n                    $" + _vm._s(_vm._f("formatNumber")(_vm.stream.assoc.price)) + "\n                  ")])])] : (_vm.stream && _vm.stream.assoc_type == 'User') ? [_c('div', {
    staticClass: "media__image round",
    style: (("background-image: url(" + (_vm.stream.assoc.avatar.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v("\n                    " + _vm._s(_vm.stream.assoc.username) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n                    " + _vm._s(_vm.stream.assoc.followers) + " followers\n                  ")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media__action--hover"
  }, [_c('v-btn', {
    staticClass: "display-btn",
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openAlbumMerchPopup()
      }
    }
  }, [_c('v-icon', [_vm._v("link")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "remove-btn",
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeItem()
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 2)]], 2)])]) : _c('div', {
    staticClass: "stream-sector"
  }, [_c('div', {
    staticClass: "stream-sector__header"
  }, [_c('div', {
    staticClass: "stream-sector__header__left"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')',
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), _c('div', [_c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "dark",
      "type": "default",
      "followParam": {
        page_track: ("Stream: " + (_vm.stream.id))
      }
    }
  }), _vm._v(" "), (_vm.stream.is_reposted) ? _c('v-btn', {
    staticClass: "ml-1 px-2",
    attrs: {
      "round": "",
      "dark": "",
      "small": "",
      "color": "green"
    }
  }, [_vm._v("Reposted")]) : _c('v-btn', {
    staticClass: "ml-1 px-2",
    attrs: {
      "round": "",
      "dark": "",
      "small": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.repostStream()
      }
    }
  }, [_vm._v("Repost Stream")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__header__right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "separator"
  }), _vm._v(" "), (_vm.stream && _vm.stream.assoc_type == 'Album') ? _c('div', {
    staticClass: "stream-sector__content"
  }, [_c('div', {
    staticClass: "stream-sector__content__left"
  }, [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + (_vm.stream.assoc.cover.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n              " + _vm._s(_vm.stream.assoc.tracks.length) + " tracks\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content__right"
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.downloadAlbum()
      }
    }
  }, [_vm._v("Download")])], 1)]) : (_vm.stream && _vm.stream.assoc_type == 'ShopProduct') ? _c('div', {
    staticClass: "stream-sector__content"
  }, [_c('div', {
    staticClass: "stream-sector__content__left"
  }, [_c('div', {
    staticClass: "media__image",
    style: (("background-image: url(" + (_vm.stream.assoc.covers[0].cover.thumb.url) + ")"))
  }, [_c('div', {
    staticClass: "media__image--hover",
    on: {
      "click": function($event) {
        _vm.removeProductFromCart()
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.name))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n              $" + _vm._s(_vm._f("formatNumber")(_vm.stream.assoc.price)) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content__right"
  }, [(_vm.isInCart) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "green"
    }
  }, [_vm._v("Added to Cart")]) : _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openMerchModal()
      }
    }
  }, [_vm._v("Add to Cart")])], 1)]) : (_vm.stream && _vm.stream.assoc_type == 'User') ? _c('div', {
    staticClass: "stream-sector__content"
  }, [_c('div', {
    staticClass: "stream-sector__content__left"
  }, [_c('div', {
    staticClass: "media__image round",
    style: (("background-image: url(" + (_vm.stream.assoc.avatar.thumb.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "media__content"
  }, [_c('div', {
    staticClass: "media__title"
  }, [_vm._v(_vm._s(_vm.stream.assoc.username))]), _vm._v(" "), _c('div', {
    staticClass: "media__description"
  }, [_vm._v("\n              " + _vm._s(_vm.stream.assoc.followers) + " followers\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "stream-sector__content__right"
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue"
    },
    nativeOn: {
      "click": function($event) {
        _vm.visitProfile()
      }
    }
  }, [_vm._v("Visit")])], 1)]) : _vm._e()]), _vm._v(" "), (_vm.show_album_merch_popup) ? _c('div', {
    staticClass: "album-merch-popup requests"
  }, [_c('div', {
    staticClass: "dismiss-section",
    on: {
      "click": function($event) {
        _vm.closeAlbumMerchPopup()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-section"
  }, [_c('div', {
    staticClass: "requests-section"
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v("Attach content to live video")]), _vm._v(" "), _c('div', {
    staticClass: "option-area"
  }, [_c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'Album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('Album')
      }
    }
  }, [_vm._v("Album")]), _vm._v(" "), _c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'ShopProduct'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('ShopProduct')
      }
    }
  }, [_vm._v("Product")])], 1)]), _vm._v(" "), (_vm.request_tab == 'Album') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.albums), function(album) {
    return _c('div', {
      key: album.id,
      staticClass: "request-item",
      class: {
        selected: _vm.assoc.id == album.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('Album', album)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.request_tab == 'ShopProduct') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.id,
      staticClass: "request-item",
      class: {
        selected: _vm.assoc.id == product.id
      },
      on: {
        "click": function($event) {
          _vm.selectItem('ShopProduct', product)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e()])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('i', {
    ref: "closeButton",
    staticClass: "fa fa-close close-btn",
    on: {
      "click": function($event) {
        _vm.closePlayer()
      }
    }
  }), _vm._v(" "), (_vm.user) ? [_c('v-dialog', {
    attrs: {
      "content-class": "stream-view-confirm-dialog"
    },
    model: {
      value: (_vm.show_streaming_confirm_dialog),
      callback: function($$v) {
        _vm.show_streaming_confirm_dialog = $$v
      },
      expression: "show_streaming_confirm_dialog"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__caption"
  }, [_vm._v("Live")]), _vm._v(" "), _c('div', {
    staticClass: "box__content"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v(_vm._s(_vm.stream.name))]), _vm._v(" "), _c('div', {
    staticClass: "box__subtitle"
  }, [_vm._v("\n            " + _vm._s(_vm._.get(_vm.stream, "user.username")) + "\n            "), _c('v-icon', [_vm._v("fa-check-circle")])], 1), _vm._v(" "), _c('label', {
    staticClass: "stream-genre"
  }, [_vm._v(_vm._s(_vm._.get(_vm.stream, "genre.name")))])]), _vm._v(" "), _c('div', {
    staticClass: "box__header"
  }, [_c('label', [_vm._v(_vm._s(_vm._f("formatDateFromNow")(_vm.stream.started_at)))])]), _vm._v(" "), _c('div', {
    staticClass: "box__image",
    style: (("background-image: url(" + (_vm._.get(_vm.stream, 'cover.url')) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "box__footer"
  }, [(_vm.can_view) ? _c('v-btn', {
    class: {
      'theme--dark': _vm.enabledPlaying
    },
    attrs: {
      "block": "",
      "disabled": !_vm.enabledPlaying
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("Watch" + _vm._s(_vm.latencyTime))]) : (_vm.exceed_capacity) ? _c('div', [_vm._v("\n            Sorry,"), _c('br'), _vm._v("\n            Broadcast is at capacity\n          ")]) : _c('v-btn', {
    attrs: {
      "dark": "",
      "block": ""
    },
    on: {
      "click": _vm.openPaymentDialog
    }
  }, [_vm._v("Pay $" + _vm._s(_vm._f("formatNumber")(_vm.stream.view_price)))])], 1)])]), _vm._v(" "), (_vm.show_merch_modal) ? _c('merch-modal', {
    attrs: {
      "item": _vm.product,
      "dismiss": _vm.closeMerchModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_share_dialog) ? _c('share-modal', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.closeShareDialog
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_payment_dialog),
      callback: function($$v) {
        _vm.show_payment_dialog = $$v
      },
      expression: "show_payment_dialog"
    }
  }, [(_vm.show_payment_dialog) ? _c('payment-modal', {
    attrs: {
      "receivers": [_vm.stream.user],
      "amount": _vm.stream.view_price,
      "dismiss": _vm.closePaymentDialog,
      "finish": _vm.payViewStream
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_stream_delete_confirm_dialog),
      callback: function($$v) {
        _vm.show_stream_delete_confirm_dialog = $$v
      },
      expression: "show_stream_delete_confirm_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete a Stream")]), _vm._v(" "), _c('v-card-text', [_vm._v("If you click OK, the stream will no longer be available. Click OK to\n        delete, or click Cancel.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.archiveStream()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeStreamDeleteConfirmDialog()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4496dd71","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stream_player.vue
// module id = 1705
// module chunks = 180